<template>
  <div style="width: 100%">
    <!-- <div class="toolbar"></div> -->
    <Editor
      :id="id"
      :class="['outline-class', showToolbar ? 'editorcontent' : '']"
      v-model="content"
      :init="editorInit"
    ></Editor>
  </div>
</template>

<script>
import axios from "axios";
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver/theme";
import "tinymce/icons/default/icons.min.js"; // 引入富文本编辑器图标
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/media";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/hr";
import "tinymce/plugins/paste";
import "tinymce/plugins/autoresize";
import "@/assets/tinymce/plugins/indent2em";
import "@/assets/tinymce/plugins/lineheight";
import "@/assets/tinymce/plugins/formatpainter";

var vm = {
  name: "editTinymce",
  components: {
    Editor,
  },
  created() {
    // for (var key in this.values) {
    //   if (key == this.id) {
    //     this.content = this.values[key];
    //     break;
    //   }
    // }
  },
  mounted() {
    tinymce.init({});
    // var ifra = window.document.getElementById(this.id);

    // ifra = ifra.getElementsByTagName("iframe")[0];

    // this.keepLastIndex(
    //   ifra.contentWindow.document.getElementById("tinymce"),
    //   ifra.contentWindow
    // );
  },
  props: {
    id: {
      // 编辑器id
      type: String,
      require: true,
    },
    value: {
      type: [String, Object],
      require: true,
    },
    showToolbar: {
      // 是否显示富文本工具栏
      type: Boolean,
      default: false,
    },
    placeholder: {
      // 编辑器占位符
      type: String,
      default: "",
    },
    minHeight: {
      type: Number,
      default: 62,
    },
    initFontSize: {
      type: String,
      default: "",
    },
    initWithBold: {
      type: Boolean,
      default: false,
    },
    bodyClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // values: {
      //   chineseTitle: {
      //     type: String,
      //     default: "",
      //   },

      //   englishTitle: {
      //     type: String,
      //     default: "",
      //   },

      //   chineseSummary: {
      //     type: String,
      //     default: "",
      //   },

      //   englishSummary: {
      //     type: String,
      //     default: "",
      //   },
      // },
      content: "",

      editorInit: {
        // auto_focus: true,
        // 富文本配置
        selector: `#${this.id}`,
        body_class: this.bodyClass,
        remove_trailing_brs: true,
        nowrap: true,
        content_style:
          "body{margin:0; font-size:14px;} .chineseTitle.mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {color: #999;font-size: 36px;line-height:1.5;} .chineseTitle p{font-size:36px;margin:0;line-height:1.5;display:inline;} .englistTitle p{margin:0 !important;font-size:14px !important; line-height:1.5; padding-top:6px;color: #515a6e;} .englistTitle.mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {color: #999;font-size: 14px !important;line-height:1.5;top:6px;}",
        // inline: true,
        language_url: "/admin/tinymce/zh_CN.js", // 中文语言包路径
        language: "zh_CN",
        skin_url: "/admin/tinymce/skins/ui/oxide", // 富文本css图标路径
        height: "100%", // 高度
        // height: 40,

        statusbar: false, // 隐藏编辑器下方内容
        menubar: false, // 隐藏菜单栏
        placeholder: `${this.placeholder}`, // 占位内容

        // max_width: "100%", // 宽度
        // min_height: this.minHeight,
        // autoresize_on_init: true,
        fontsize: this.initFontSize,
        plugins:
          "wordcount media indent2em hr lineheight formatpainter autoresize paste ",
        autoresize_bottom_margin: 0,
        paste_preprocess: function (plugin, args) {
          // console.log(args.content);
          // 正则过滤除sub和sup以外的所有标签 /(?!<(sub|sup).*?>)<.*?>/g
          var res = args.content.replace(/(?!<(\/?sub|\/?sup).*?>)<.*?>/g, "");
          // console.log(res);
          // res = res.trim();
          args.content = res;
        },
        toolbar: false, // 工具栏 paste
        bold: { inline: "span", classes: "bold" },
        setup: function (editor) {
          // console.log("this.initFontSize", this);
          // 设置富文本编辑框内容固定样式
          editor.on("init", function () {
            // console.log("init", this, vm.props.initFontSize.default);
            // this.execCommand("fontName", false, "Microsoft YaHei");
            // this.execCommand("fontSize", false, vm.props.initFontSize.default);
            // this.execCommand("lineHeight", false, "1.5");
            this.focus()
          });
          editor.on("input focus change keyup keydown blur", function (params) {
            if (
              (params.type == "keyup" || params.type == "keydown") &&
              (params.key == "Enter" || params.which == 13)
            ) {
              params.cancelBubble = true;
              params.preventDefault();
              params.stopPropagation();
              return;
            }
            // console.log(params, editor);
            // var ifra = window.document.getElementById(editor.id);

            // ifra = editor.iframeElement;

            // vm.methods.keepLastIndex(
            //   ifra.contentWindow.document.getElementById("tinymce"),
            //   ifra.contentWindow
            // );

            // var conentsStr = "";
            // var elems = this.getContentAreaContainer().children;

            // elems.forEach((elem) => {
            //   if (elem.children.length == 0) {
            //     conentsStr += elem.innerHTML;
            //   } else {
            //     elem.children.forEach((e) => {
            //       conentsStr += e.innerHTML;
            //     });
            //   }
            // });
            // conentsStr = conentsStr.trim();
            // console.log(elems, conentsStr, conentsStr.length);

            // vm.content = conentsStr;
          });
          editor.on("PostProcess", function (ed) {
            // we are cleaning empty paragraphs
            ed.content = ed.content.replace(/(<p>)/gi, "");
            ed.content = ed.content.replace(/(<\/p>)/gi, "");
          });
        },
      },
    };
  },
  watch: {
    value(newVla) {
      this.content = newVla;
    },
    content(newVla) {
      var params = {
        id: this.id,
        value: newVla,
      };
      params = JSON.stringify(params);

      this.$emit("changeValue", params);
    },
  },
  methods: {
    // keepLastIndex(obj, window) {
    //   if (window.getSelection) {
    //     //ie11 10 9 ff safari
    //     obj.focus(); //解决ff不获取焦点无法定位问题
    //     var range = window.getSelection(); //创建range
    //     range.selectAllChildren(obj); //range 选择obj下所有子内容
    //     range.collapseToEnd(); //光标移至最后
    //   } else if (document.selection) {
    //     //ie10 9 8 7 6 5
    //     var range = document.selection.createRange(); //创建选择对象
    //     range.moveToElementText(obj); //range定位到obj
    //     range.collapse(false); //光标移至最后
    //     range.select();
    //   }
    // },
  },
};

// var editorInit0 = {
//   // 富文本配置
//   selector: `#${vm.id}`,
//   content_style:
//     "p {margin: 10px; border: 5px solid red; padding: 3px;backrgound:red;}",
//   // inline: true,
//   language_url: "/admin/tinymce/zh_CN.js", // 中文语言包路径
//   language: "zh_CN",
//   skin_url: "/admin/tinymce/skins/ui/oxide", // 富文本css图标路径
//   // height: "100%", // 高度

//   statusbar: false, // 隐藏编辑器下方内容
//   menubar: false, // 隐藏菜单栏
//   placeholder: `${vm.placeholder}`, // 占位内容
//   // max_width: "100%", // 宽度
//   min_height: vm.minHeight,
//   autoresize_on_init: true,
//   fontsize: vm.initFontSize,
//   plugins:
//     "wordcount media indent2em hr lineheight formatpainter autoresize paste ",
//   paste_preprocess: function (plugin, args) {
//     console.log(args.content);
//     // 正则过滤除sub和sup以外的所有标签 /(?!<(sub|sup).*?>)<.*?>/g
//     var res = args.content.replace(/(?!<(\/?sub|\/?sup).*?>)<.*?>/g, "");
//     console.log(res);
//     args.content = res;
//   },
//   toolbar: false, // 工具栏 paste
//   bold: { inline: "span", classes: "bold" },
//   setup: function (editor) {
//     // console.log("this.initFontSize", this);
//     // 设置富文本编辑框内容固定样式
//     editor.on("init", function () {
//       this.execCommand("fontName", false, "Microsoft YaHei");
//       this.execCommand("fontSize", false, this.fontsize);
//       this.execCommand("lineHeight", false, "1.5");
//     });
//     editor.on("input blur", function (params) {
//       var conentsStr = "";
//       var elems = this.getContentAreaContainer().children;

//       elems.forEach((elem) => {
//         if (elem.children.length == 0) {
//           conentsStr += elem.innerHTML;
//         } else {
//           elem.children.forEach((e) => {
//             conentsStr += e.innerHTML;
//           });
//         }
//       });
//       // conentsStr = conentsStr.trim();
//       console.log(elems, conentsStr, conentsStr.length);

//       vm.content = conentsStr;
//     });
//   },
// };
export default vm;
</script>

<style lang="scss" scoped>
// .toolbar {
//   position: -webkit-sticky;
//   position: sticky;
//   overflow: hidden;
//   top: 106px;
//   z-index: 999;
//   // &::v-deep .tox-toolbar {
//   //   background-color: #f6f6f7;
//   // }
// }

// .mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {
//   color: #999 !important;
//   font-size: 36px;
//   content: attr(data-mce-placeholder);
//   position: absolute;
// }

::v-deep iframe .mce-content-body {
  background: red !important;
}
.outline-class {
  outline-color: #d5e8fc;
}
.editorcontent {
  // min-height: 200px;
  // max-height: 500px;
  // overflow: auto;
  color: #515a6e;
}
::v-deep .tox-tinymce {
  border: 0;
  // height: 70px !important;
}
.toolbarHeaderFixed {
  position: fixed;
  top: 105px;
  left: 0;
  background: rgb(236 235 235 / 96%);
  width: 100%;
  .toolbarOverlord {
    width: 1200px;
    margin: 0 auto;
    background: rgb(236 235 235 / 96%);
    padding: 0 100px;
  }
  .toolbarPrimary {
    background: none !important;
  }
}
.tox-tinymce {
}
</style>
